import {combineReducers} from 'redux'
import Immutable from 'seamless-immutable'
import types from 'actions/types'

export const isSendCopyEnabled = (state = Immutable(true), action) => {
  switch (action.type) {
    case types.EMAILING_TOGGLE_SEND_COPY_FROM:
      return !state
    default:
      return state
  }
}

export const quotingEmailFromName = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.QUOTING_SET_EMAIL_FROM_NAME:
      return action.emailFromName
    default:
      return state
  }
}

export const quotingEmailReplyTo = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.QUOTING_SET_EMAIL_REPLY_TO:
      return action.emailReplyTo
    default:
      return state
  }
}

export const purchasingEmailFromName = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.PURCHASING_SET_EMAIL_FROM_NAME:
      return action.emailFromName
    default:
      return state
  }
}

export const purchasingEmailReplyTo = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.PURCHASING_SET_EMAIL_REPLY_TO:
      return action.emailReplyTo
    default:
      return state
  }
}

export const deliveriesEmailFromName = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTE_SET_EMAIL_FROM_NAME:
      return action.emailFromName
    default:
      return state
  }
}

export const deliveriesEmailReplyTo = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTE_SET_EMAIL_REPLY_TO:
      return action.emailReplyTo
    default:
      return state
  }
}

export const invoicingEmailFromName = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.INVOICING_SET_EMAIL_FROM_NAME:
      return action.emailFromName
    default:
      return state
  }
}

export const invoicingEmailReplyTo = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.INVOICING_SET_EMAIL_REPLY_TO:
      return action.emailReplyTo
    default:
      return state
  }
}

export default combineReducers({
  isSendCopyEnabled,
  quotingEmailFromName,
  quotingEmailReplyTo,
  purchasingEmailFromName,
  purchasingEmailReplyTo,
  deliveriesEmailFromName,
  deliveriesEmailReplyTo,
  invoicingEmailFromName,
  invoicingEmailReplyTo,
})
